// API base URL per environment. Pick one at build/start time with REACT_APP_ENV
// (see "start:uat" / "build:uat" in package.json), or override it entirely with
// REACT_APP_API_URL. Defaults: `npm start` -> development, `npm run build` -> production.
const API_URLS = {
  development: "http://localhost:4007",
  uat: "https://stage-api.risify.in",
  production: "https://backend.risify.in",
};

const appEnv =
  process.env.REACT_APP_ENV ||
  (process.env.NODE_ENV === "development" ? "development" : "production");

const liveLink = (process.env.REACT_APP_API_URL || API_URLS[appEnv]).replace(/\/$/, "");

export const adminBaseUrl = `${liveLink}/v1/admin`;
export const imageUrl = `${liveLink}/v1/image`;
export const userBaseUrl = `${liveLink}/v1/user`;
export const otpUrl = `${liveLink}/v1/otp`;
export const commonBaseUrl = `${liveLink}/v1/common`;
export const cpBaseUrl = `${liveLink}/v1/cp`;
